import cn from 'clsx';
import { FC } from 'react';

import SettingListItem, { SettingListItemProps } from './Item/SettingListItem';
import s from './SettingList.module.scss';

export interface SettingListProps extends SettingListItemProps {
  onClick?: () => void;
  className?: string;
}

const SettingList: FC<React.PropsWithChildren<React.PropsWithChildren<SettingListProps>>> = ({ className, onClick, listIcon, ...props }) => {
  const handleClick = () => {
    if (onClick && listIcon) {
      onClick();
    }
  };

  return (
    <div
      className={cn(
        s.wrap,
        {
          [s.press as string]: onClick
        },
        className
      )}
      onClick={handleClick}
    >
      <SettingListItem listIcon={listIcon} {...props} />
    </div>
  );
};

export default SettingList;
